import axios from "axios";
import { API_BASE } from "../../lib/api";

const R = `${API_BASE}/rider-cash`;
const d = (p) => p.then((r) => r.data);

export const rcApi = {
  summary: () => d(axios.get(`${R}/summary`)),
  txns: (params) => d(axios.get(`${R}/txns`, { params })),
  add: (body) => d(axios.post(`${R}/txns`, body)),
  remove: (id) => d(axios.delete(`${R}/txns/${id}`)),
  confirm: (id, method) => d(axios.post(`${R}/deposits/${id}/confirm`, null, { params: { method } })),
  reject: (id, reason) => d(axios.post(`${R}/deposits/${id}/reject`, { reason })),
  importNinja: (month) => d(axios.post(`${R}/import-ninja`, null, { params: { month } })),
  upload: (file) => { const f = new FormData(); f.append("file", file); return d(axios.post(`${R}/upload`, f)); },
  templateUrl: `${R}/template`,
  settingsSave: (limit) => d(axios.put(`${R}/settings`, { limit })),
  monthEnd: (month) => d(axios.get(`${R}/month-end`, { params: { month } })),
  monthApply: (month, employee_ids) => d(axios.post(`${R}/month-end/apply`, { month, employee_ids })),
  portal: () => d(axios.get(`${API_BASE}/portal/rider-cash`)),
  portalDeposit: (form) => d(axios.post(`${API_BASE}/portal/rider-cash/deposit`, form)),
};

export const errMsg = (e) => e?.response?.data?.detail || "حدث خطأ";
export const fmt = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
export const thisMonth = () => new Date().toISOString().slice(0, 7);
export const today = () => new Date().toISOString().slice(0, 10);
export const TYPE_AR = { collect: "تحصيل نقد", deposit: "توريد", deduct: "خصم من الراتب" };
export const STATUS_AR = { pending: "بانتظار التأكيد", confirmed: "مؤكد", rejected: "مرفوض" };
export const SOURCE_AR = { manual: "يدوي", ninja: "نينجا", excel: "Excel", portal: "بوابة المندوب", payroll: "الرواتب" };
